import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem, ITypedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IDataRole } from '../types/IDataRole';

export interface IGetDataRolesParams extends IGetItemsParams {
}

export interface IGetDataRolesResult extends IGetItemsResult {
  dataRoles?: IDataRole[];
  users?: IUser[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  favorites?: string[];
}

export class GetDataRolesRequest extends Request<IGetDataRolesParams, IGetDataRolesResult> {
  constructor(params: IGetDataRolesParams) {
    super('getDataRoles', params);
  }
}
